import { APP_INITIALIZER } from '@angular/core';
import { RoutesService, eLayoutType } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';

export const GALILEU_SAIDAS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/galileu-saidas',
        name: 'Saídas Galileu',
        iconClass: 'fas fa-network-wired',
        order: 103,
        layout: eLayoutType.application,
        parentName: eThemeSharedRouteNames.Administration,
        // Permissão só do host (MultiTenancySides.Host): tenant nunca vê este item.
        requiredPolicy: 'cargo_fleet.GalileuSaidas',
      },
    ]);
  };
}
